import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import auth from '../service/auth';

function Login({ setUser }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const connexion = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const result = await auth.login(email, password);
      if (result.success) {
        setUser(result.user);
        navigate("/");
      } else {
        setError("Email ou mot de passe incorrect");
      }
    } catch (err) {
      setError("Impossible de se connecter au serveur");
    }
    setLoading(false);
  };

  return (
    <div className="w-full max-w-md">
      <div className="bg-white rounded-2xl shadow-2xl p-8">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center text-2xl shadow-lg shadow-indigo-500/30 mb-4">
            🔔
          </div>
          <h1 className="text-2xl font-bold text-slate-800">Push Service</h1>
          <p className="text-sm text-slate-500 mt-1">Connecte-toi à ta plateforme</p>
        </div>

        <form onSubmit={connexion} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Adresse mail</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="toi@example.com"
              className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Mot de passe</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          {error && (
            <div className="bg-rose-50 border border-rose-200 text-rose-700 text-sm rounded-lg px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2.5 rounded-lg transition-colors disabled:opacity-50"
          >
            {loading ? "Connexion…" : "Connexion"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
